<template>
  <v-container class="relative mb-8">
    <app-spinner v-if="loading" class="mt-4" />

    <v-container>
      <v-row>
        <v-col align="center" justify="center">
          <v-img :src="require('@/assets/reverseFlow/give_away_submitted.png')" contain height="100" />
        </v-col>
      </v-row>

      <v-row align="center" justify="center" class="mt-8">
        <v-col cols="11" class="py-0 text-center">
          <h1 class="header">Successfully Submitted!</h1>
          <div class="font-weight-light ma-3">You now have 1 entry into the giveaway 🔥</div>
        </v-col>
      </v-row>

      <v-row align="center" justify="center" class="mt-7 mb-2">
        <v-col cols="11" class="py-0 mt-3">
          <h1 class="sub-header">Next steps</h1>
        </v-col>
      </v-row>

      <v-row align="center" justify="center" class="mt-4 mb-2">
        <v-col cols="11" class="py-0">
          <v-divider />
        </v-col>
      </v-row>

      <ClaimSwayOfferSection
        v-if="offerHasSocials"
        :step-number="1"
        step-title="Follow us on social"
        step-sub-title="Winners will be announced first on our social media pages followed by personal text or email"
      >
        <v-row>
          <v-col cols="11">
            <v-btn
              v-if="offerHasFbSocials"
              rounded
              color="#3b5998"
              class="mt-6 white--text"
              max-width="350"
              :href="`https://facebook.com/${reverseFlowDeal.facebook_mentions[0]}`"
              target="_blank"
            >
              <v-icon left>mdi-facebook</v-icon>
              Tap here to follow
            </v-btn>
          </v-col>
        </v-row>

        <v-row class="mt-0">
          <v-col cols="11" class="pt-0">
            <v-btn
              v-if="offerHasIgSocials"
              rounded
              color="#e95950"
              class="mt-3 white--text"
              max-width="350"
              :href="`https://instagram.com/${reverseFlowDeal.instagram_mentions[0]}`"
              target="_blank"
            >
              <v-icon left>mdi-instagram</v-icon>
              Tap here to follow
            </v-btn>
          </v-col>
        </v-row>
      </ClaimSwayOfferSection>

      <ClaimSwayOfferSection
        v-if="reverseFlowDeal && reverseFlowDeal.expiration_description"
        :step-number="offerHasSocials ? 2 : 1"
        step-title="Giveaway end date"
        :step-sub-title="`The giveaway ends on ${reverseFlowDeal.expiration_description}`"
      />

      <ClaimSwayOfferSection
        :step-number="winnersAnnouncedStepNumber"
        step-title="Winners announced"
        step-sub-title="Winners will be announced shortly after the giveaway ends"
      />
    </v-container>
  </v-container>
</template>

<script>
import Vue from 'vue'

import { ApiService } from '@/services'

import ClaimSwayOfferSection from '@/components/sway/ClaimSwayOfferSection'

export default Vue.extend({
  name: 'VoucherSwayOffer',

  components: {
    ClaimSwayOfferSection,
  },

  metaInfo() {
    return this.reverseFlowDeal
      ? {
          title: `${this.reverseFlowDeal.offer_summary} | ${this.reverseFlowDeal.business.brand}`,
        }
      : {
          title: 'Localfluence',
        }
  },

  props: {
    swayOfferProofId: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    loading: true,
    reverseFlowDeal: null,
  }),

  computed: {
    winnersAnnouncedStepNumber: function () {
      if (this.offerHasSocials && this.reverseFlowDeal?.expiration_description) return 3
      if (this.offerHasSocials || this.reverseFlowDeal?.expiration_description) return 2
      return 1
    },
    offerHasFbSocials: function () {
      return this.reverseFlowDeal?.facebook_mentions.length > 0
    },
    offerHasIgSocials: function () {
      return this.reverseFlowDeal?.instagram_mentions.length > 0
    },
    offerHasSocials: function () {
      return this.offerHasFbSocials || this.offerHasIgSocials
    },
  },

  mounted: function () {
    ApiService.get(`reverseFlow/proof/${this.swayOfferProofId}`).then((response) => {
      this.reverseFlowDeal = response.data.reverseFlowDeal
      this.loading = false
    })
  },
})
</script>

<style scoped>
.header {
  font-size: 26px;
  font-weight: 700;
  line-height: 1.1em;
}

.sub-header {
  font-size: 20px;
  font-weight: 700;
  line-height: 1.1em;
}
</style>
